module.exports = __webpack_public_path__ + "static/3be2e96243187da0b31b4b25d7fd7b01.png";